'use client';

import type { ReactNode } from 'react';
import { PaywallaxSpacer } from '@/app_components/Paywall/PaywallaxSpacer';
import { usePaywall } from '@/app_lib/providers/PaywallProvider';

export const FooterWrapperWithPaywallAxSpacer = ({ children }: { children: ReactNode }) => {
  const { showPaywallax } = usePaywall();
  return (
    <div>
      {children}
      {showPaywallax && <PaywallaxSpacer />}
    </div>
  );
};
